import React, { useState } from 'react';
import { Modal, Button } from '../../components/ds';
import api from '../../api/client';

export const TARGETING_OPTIONS = [
  { key: 'frequency_cap', label: 'Frequency Cap' },
  { key: 'day_parts', label: 'Day Parts' },
  { key: 'keywords', label: 'Keywords' },
  { key: 'audience', label: 'Audience' },
];

export default function FeaturesModal({ accountUuid, features, onClose, onSaved }) {
  const [targeting, setTargeting] = useState(
    features?.targeting || {
      frequency_cap: true,
      day_parts: true,
      keywords: true,
      audience: false,
    }
  );
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleToggle = (key) => {
    setTargeting((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    setError('');
    try {
      await api.updateAccountFeatures(accountUuid, { targeting });
      onSaved({ targeting });
    } catch (err) {
      setError('Failed to update features: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal title="Edit Feature Settings" onClose={onClose} footer={
      <>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
          {submitting ? 'Saving...' : 'Save'}
        </Button>
      </>
    }>
      <h3 style={{ marginBottom: 12, fontSize: 15, color: 'var(--text-secondary)' }}>
        Targeting
      </h3>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {TARGETING_OPTIONS.map((opt) => (
          <label
            key={opt.key}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '10px 12px',
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer',
              border: '1px solid var(--border-color)',
              backgroundColor: targeting[opt.key] ? 'var(--bg-secondary)' : 'transparent',
            }}
          >
            <input
              type="checkbox"
              checked={targeting[opt.key] || false}
              onChange={() => handleToggle(opt.key)}
              style={{ width: 18, height: 18 }}
            />
            <span style={{ fontWeight: 500 }}>{opt.label}</span>
          </label>
        ))}
      </div>

      {error && <div className="error-text">{error}</div>}
    </Modal>
  );
}
